import React, { Suspense, useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { resourceCache } from 'use-async-resource';
import ErrorBoundary from '../ErrorBoundary';

export const AsyncOptionsSection = <T,>({ load, children }: {
    load: () => Promise<T>;
    children: React.ReactNode;
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [attempt, setAttempt] = useState(0);

    const retry = () => {
        resourceCache(load).clear();
        setAttempt(value => value + 1);
    };

    return (
        <ErrorBoundary key={attempt} fallback={
            <Alert variant='danger' className='w-80p' role='alert'>
                <p>{t('optionsSectionLoadError')}</p>
                <Button type='button' variant='outline-secondary' onClick={retry}>
                    {t('retryLoad')}
                </Button>
            </Alert>
        }>
            <Suspense fallback={<div className='w-80p py-3' role='status'><Spinner animation='border' /></div>}>
                {children}
            </Suspense>
        </ErrorBoundary>
    );
};
